<div class="row">
    <div class="col-lg-12 col-xl-10 offset-xl-1">


        <div class="row" *ngIf="mode === 'stepthrough'">
            <div class="col-9">
                <h3 class="m-0">Editing {{overlayData.productType.name}} Configuration</h3>
            </div>
            <div class="col-3 text-end">
                <button type="button" class="btn btn-round btn-primary-reverse" (click)="close()"
                    *ngIf="!areActionButtonsHidden">
                    Back
                </button>
            </div>
        </div>

        <div *ngIf="currentTexture">
            <ul class="nav nav-tabs mt-3">
                <li class="nav-item" (click)="getTexture(ct, true)" *ngFor="let f of configuration; let ct = index">
                    <a [ngClass]="{'active' : currentTexture.id === f.id}" class="nav-link">{{f.name}}</a>
                </li>
            </ul>
        </div>

        <ng-container *ngIf="currentTexture">
            <div class="row">
                <div class="col-4">
                    <div class="d-flex align-items-center mt-3">
                        <a (click)="toggleSupplied()">
                            <i class="toggle fa" [ngClass]="{
                           'fa-toggle-on text-success': currentTexture.supplied,
                           'fa-toggle-off' : !currentTexture.supplied}"></i>
                            Supply this product as {{currentTexture.name}}
                        </a>
                    </div>

                </div>
                <div class="col-4">
                    <div class="d-flex align-items-center mt-3" *ngIf="currentTexture.supplied">
                        <a (click)="toggleAllowRandom()">
                            <i class="toggle fa"
                                [ngClass]="{'fa-toggle-on text-success': currentTexture.allowRandom, 'fa-toggle-off' : !currentTexture.allowRandom}"></i>
                            Allow random width/length?
                        </a>
                    </div>
                </div>
                <div class="col-4">
                    <div class="d-flex align-items-center mt-3">
                        <a (click)="toggleAllowBespoke()">
                            <i class="toggle fa"
                                [ngClass]="{'fa-toggle-on text-success': currentTexture.allowBespoke, 'fa-toggle-off' : !currentTexture.allowBespoke}"></i>
                            Allow bespoke orders?
                        </a>
                    </div>

                </div>
            </div>


            <ng-container *ngIf="currentTexture.supplied">
                <div class="mt-3" style="border-bottom: 1px solid #CCC" *ngIf="currentTexture.allowBespoke">
                    <div class="row">
                        <div class="col-6">
                            <div class="mb-3 row">
                                <label class="col-sm-4 col-form-label my-auto">Bespoke Margin</label>
                                <div class="col-sm-8 input-group">
                                    <input type="number" class="form-control bordered" (ngModelChange)="saveTexture()"
                                        [(ngModel)]="currentTexture.margin" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3" style="border-bottom: 1px solid #CCC" *ngIf="currentTexture.allowBespoke">
                    <h4>Restrictions</h4>
                    <div class="row">
                        <div class="col-6">
                            <div class="mb-3 row">
                                <label class="col-sm-4 col-form-label my-auto">Min Width</label>
                                <div class="col-sm-8 input-group">
                                    <input type="number" class="form-control bordered" (ngModelChange)="saveTexture()"
                                        [(ngModel)]="currentTexture.restrictions.width.min" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3 row">
                                <label class="col-sm-4 col-form-label my-auto">Max Width</label>
                                <div class="col-sm-8 input-group">
                                    <input type="number" class="form-control bordered" (ngModelChange)="saveTexture()"
                                        [(ngModel)]="currentTexture.restrictions.width.max" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <div class="mb-3 row">
                                <label class="col-sm-4 col-form-label my-auto">Min Length</label>
                                <div class="col-sm-8 input-group">
                                    <input type="number" class="form-control bordered" (ngModelChange)="saveTexture()"
                                        [(ngModel)]="currentTexture.restrictions.length.min" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3 row">
                                <label class="col-sm-4 col-form-label my-auto">Max Length</label>
                                <div class="col-sm-8 input-group">
                                    <input type="number" class="form-control bordered" (ngModelChange)="saveTexture()"
                                        [(ngModel)]="currentTexture.restrictions.length.max" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <div class="mb-3 row">
                                <label class="col-sm-4 col-form-label my-auto">Min Thickness</label>
                                <div class="col-sm-8 input-group">
                                    <input type="number" class="form-control bordered" (ngModelChange)="saveTexture()"
                                        [(ngModel)]="currentTexture.restrictions.height.min" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="mb-3 row">
                                <label class="col-sm-4 col-form-label my-auto">Max Thickness</label>
                                <div class="col-sm-8 input-group">
                                    <input type="number" class="form-control bordered" (ngModelChange)="saveTexture()"
                                        [(ngModel)]="currentTexture.restrictions.height.max" />
                                    <div class="input-group-append">
                                        <span class="input-group-text">mm</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-3" style="border-bottom: 1px solid #CCC"
                    *ngIf="currentTexture.allowBespoke && mode === 'stepthrough'">
                    <h4>Bespoke lead times</h4>

                    <div class="row mt-3">
                        <div class="col-3"><label class="col-form-label">Min units</label></div>
                        <div class="col-3"><label class="col-form-label">Max units</label></div>
                        <div class="col-6"><label class="col-form-label">Days lead time</label></div>
                    </div>

                    <div class="row" *ngFor="let l of currentTexture.leadtimes; let prIndex = index">
                        <div class="col-3">
                            <input [(ngModel)]="l.minUnit" (ngModelChange)="saveTexture()" type="number"
                                class="form-control mb-1 bordered" [placeholder]="'From'" />
                        </div>
                        <div class="col-3">
                            <input [(ngModel)]="l.maxUnit" (ngModelChange)="saveTexture()" type="number"
                                class="form-control mb-1 bordered" [placeholder]="'To'" />
                        </div>
                        <div class="col-5">
                            <input [(ngModel)]="l.days" (ngModelChange)="saveTexture()" type="number"
                                class="form-control mb-1 bordered" [placeholder]="'Days'" />
                        </div>
                        <div class="col-1">
                            <a (click)="removeLeadtime(prIndex)">
                                <img src="assets/images/icon-trash.svg" class="product-type-config-trash">
                            </a>
                        </div>
                    </div>
                    <div class="text-end mt-2 mb-4">
                        <button type="button" class="btn btn-round btn-slim btn-primary" (click)="addLeadtime()">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>


                </div>

                <div class="mt-3" style="border-bottom: 1px solid #CCC">
                    <div class="" *ngIf="currentSubType">
                        <h4>Finishes</h4>
                        <!-- <ul class="nav nav-tabs">
                            <li
                                class="nav-item"
                                (click)="getSubType(cst)"
                                *ngFor="let st of currentTexture.subTypes; let cst = index">
                                <a
                                    [ngClass]="{'active' : currentSubType.id === st.id}"
                                    class="nav-link">{{st.name}}</a>
                            </li>
                        </ul> -->
                    </div>

                    <div class="row mt-4" *ngIf="currentSubType">
                        <div class="col-4 mb-3" *ngIf="overlayData.productType.allowEdgeFinishing">
                            <h4>Edge (PLM)</h4>
                            <div *ngFor="let f of currentSubType.finishesEdge; let fei = index">
                                <a (click)="toggleFinishes('finishesEdge', fei)">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                                    {{f.name}}
                                </a>
                            </div>

                        </div>
                        <div class="col-4 mb-3" *ngIf="overlayData.productType.allowAdditionalFinish">
                            <h4>Weathered (PSM)</h4>
                            <div *ngFor="let f of currentSubType.finishesAdditional; let fai = index">
                                <a (click)="toggleFinishes('finishesAdditional', fai)">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                                    {{f.name}}
                                </a>
                            </div>

                        </div>

                        <div class="col-4 mb-3">
                            <h4>Surface (PSM)</h4>
                            <div *ngFor="let f of currentSubType.finishesTop; let fti = index">
                                <a (click)="toggleFinishes('finishesTop', fti)">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                                    {{f.name}}
                                </a>
                            </div>

                        </div>

                        <div class="col-4 mb-3" *ngIf="overlayData.productType.allowFinishBottom">
                            <h4>Underside (PLM)</h4>
                            <div *ngFor="let f of currentSubType.finishesBottom; let fbi = index">
                                <a (click)="toggleFinishes('finishesBottom', fbi)">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': f.selected, 'fa-toggle-off' : !f.selected}"></i>
                                    {{f.name}}
                                </a>
                            </div>

                        </div>
                    </div>

                </div>

                <!-- start of pricing -->
                <ng-container *ngIf="currentTexture.pricingMethod">
                    <h4 class="mt-3">Pricing methods</h4>
                    <ul class="nav nav-tabs">
                        <li class="nav-item" *ngFor="let method of currentTexture.pricingMethods">
                            <a class="nav-link" [ngClass]="{'active' : method.id === currentTexture.pricingMethod.id}"
                                (click)="setPricingMethod(method)">
                                <i class="fa fa-check"
                                    [ngClass]="{'text-success' : method.active, 'text-light' : !method.active}"></i>
                                {{method.name}}
                            </a>
                        </li>
                    </ul>


                    <ng-container *ngIf="currentTexture.pricingMethod.id === 'ST'">
                        <div class="mt-3">
                            <h5 class="mt-3">Standard product pricing will be applied</h5>
                            <div class="d-flex align-items-center mt-3">
                                <a (click)="togglePricingMethodActive()">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': currentTexture.pricingMethod.active, 'fa-toggle-off' : !currentTexture.pricingMethod.active}"></i>
                                    <span *ngIf="currentTexture.pricingMethod.active"> This pricing method is
                                        activated</span>
                                    <span *ngIf="!currentTexture.pricingMethod.active"> This pricing method is not
                                        activated</span>
                                </a>
                            </div>
                            <div *ngIf="currentTexture.pricingMethod.active">
                                <app-standard-stone-pricing [costGroups]="currentTexture.standardPricing">
                                </app-standard-stone-pricing>
                            </div>

                        </div>
                    </ng-container>


                    <ng-container *ngIf="currentTexture.pricingMethod.id === 'CM'">
                        <div class="mt-3">
                            <h5 class="mt-3">This product pricing will be calculated from a base cubic metre cost of
                                {{overlayData.range.baseCost | currency: 'GBP'}}</h5>
                            <div class="d-flex align-items-center mt-3">
                                <a (click)="togglePricingMethodActive()">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': currentTexture.pricingMethod.active, 'fa-toggle-off' : !currentTexture.pricingMethod.active}"></i>
                                    <span *ngIf="currentTexture.pricingMethod.active"> This pricing method is
                                        activated</span>
                                    <span *ngIf="!currentTexture.pricingMethod.active"> This pricing method is not
                                        activated</span>
                                </a>
                            </div>
                        </div>

                    </ng-container>

                    <ng-container *ngIf="currentTexture.pricingMethod.id === 'PSM'">
                        <div class="mt-3">
                            <h5 class="mt-3">Product pricing will be calculated from the parameters below</h5>
                            <div class="d-flex align-items-center mt-3">
                                <a (click)="togglePricingMethodActive()">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': currentTexture.pricingMethod.active, 'fa-toggle-off' : !currentTexture.pricingMethod.active}"></i>
                                    <span *ngIf="currentTexture.pricingMethod.active"> This pricing method is
                                        activated</span>
                                    <span *ngIf="!currentTexture.pricingMethod.active"> This pricing method is not
                                        activated</span>
                                </a>
                            </div>
                        </div>

                        <ng-container *ngIf="currentTexture.pricingMethod.active">
                            <ng-container *ngIf="currentTexture && overlayData.productType.sellUnits.length">
                                <div class="mt-3" style="border-bottom: 1px solid #CCC">

                                    <ul class="nav nav-tabs">
                                        <li class="nav-item" (click)="setPricingGroup('random')">
                                            <a [ngClass]="{'active' : currentPricingGroup === 'random'}"
                                                class="nav-link">Random</a>
                                        </li>
                                        <li class="nav-item" (click)="setPricingGroup('setWidthRandom')">
                                            <a [ngClass]="{'active' : currentPricingGroup === 'setWidthRandom'}"
                                                class="nav-link">Set Width Random Length</a>
                                        </li>
                                        <li class="nav-item" (click)="setPricingGroup('setWidthSetLength')">
                                            <a [ngClass]="{'active' : currentPricingGroup === 'setWidthSetLength'}"
                                                class="nav-link">Set Width Set Length</a>
                                        </li>
                                    </ul>
                                    <div class="row mt-3"
                                        *ngFor="let o of currentTexture.costsSQM[currentPricingGroup]; let prIndex = index">
                                        <div class="col-3">
                                            <input [(ngModel)]="o.minThickness" (ngModelChange)="saveTexture()"
                                                type="number" class="form-control bordered mb-1"
                                                [placeholder]="'From'" />
                                        </div>
                                        <div class="col-3">
                                            <input [(ngModel)]="o.maxThickness" (ngModelChange)="saveTexture()"
                                                type="number" class="form-control bordered mb-1" [placeholder]="'To'" />
                                        </div>
                                        <div class="col-5">
                                            <input [(ngModel)]="o.cost" (ngModelChange)="saveTexture()" type="number"
                                                class="form-control bordered mb-1" [placeholder]="'Price'" />
                                        </div>
                                        <div class="col-1">
                                            <a
                                                (click)="removeRangeRow(currentTexture.costsSQM[currentPricingGroup], prIndex)">
                                                <img src="assets/images/icon-trash.svg" class="product-type-config-trash">
                                            </a>
                                        </div>
                                    </div>
                                    <div class="text-end mt-2 mb-3">
                                        <button class="btn btn-round btn-slim btn-primary"
                                            (click)="addRangeRow(currentTexture.costsSQM[currentPricingGroup])" type="button">
                                            <i class="fa fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </ng-container>


                        </ng-container>
                    </ng-container>

                </ng-container>
                <!-- end of pricing -->
            </ng-container>
        </ng-container>


        <ng-container *ngIf="!areActionButtonsHidden">
            <div class="row mt-4">
                <div class="col-6">
                </div>
                <div class="col-6 text-end">
                    <button type="button" class="btn btn-round btn-primary" (click)="submit()">
                        Submit
                    </button>
                </div>
            </div>
            <div class="mt-2 text-end" *ngIf="mode === 'stepthrough'">
                <p>Click 'Submit' to save configuration and return to the last step</p>
            </div>
        </ng-container>

    </div>
</div>
